
import React, {useState, useEffect} from "react";

import {Link, useNavigate, useParams } from 'react-router-dom';
import DashboardLeftNav from "../inc/DashboardLeftNav";

// import {useNavigate } from 'react-router-dom';

import axios from "axios";

import validator from "validator";
import Swal from "sweetalert2";

// axios.defaults.baseURL='https://suvivah.org/suvivah/api/';

// const img_path = "https://suvivah.org/suvivah/";



function DashboardContent() {

    const [progress,setProgress]=useState(0);
    const [loader,setLoader]=useState(false);

    let [basicinfo,setBasicinfo]=useState("");
    const [isPhoneLocked, setIsPhoneLocked] = useState(false);
    const [isEmailLocked, setIsEmailLocked] = useState(false);
    const [isGenderLocked, setIsGenderLocked] = useState(false);


    let navigate = useNavigate();

    async function showprofile() {

        setProgress(100);
        setLoader(true);

      
        var fd=new FormData();
        fd.append("pid",localStorage.getItem("pid"));
        var resp=await axios.post("https://suvivah.org/suvivah/api/showprofile",fd);
        var data=resp.data;
        // console.log(data);
        setBasicinfo(data);

        setName(data.name);
        setEmail(data.email);
        setGender(data.gender);
        setPhone(data.phone);

        setIsPhoneLocked(data.phone !== null && data.phone !== "");
        setIsEmailLocked(data.email !== null && data.email !== "");
        setIsGenderLocked(data.gender !== null && data.gender !== "");    
        
    }

    let [name,setName]=useState("");
    let [email,setEmail]=useState("");
    let [gender,setGender]=useState("");
    let [phone,setPhone]=useState("");
    let [nameerr,setNameerr]=useState(false);
    let [emailerr,setEmailerr]=useState(false);
    let [gendererr,setGendererr]=useState(false);
    let [phoneerr,setPhoneerr]=useState(false);
    
    // let [msg,setMsg]=useState("");
    let [ismsg,setIsmsg]=useState(false);

    async function updatedashboard() {
        var flag=1;

        // alert(name+', '+email+', '+gender+', '+phone)
        setIsmsg(false);
        
        if (name.length==0) {
            setNameerr(true);
            flag=0;
        }
        if (!validator.isEmail(email)) {
            setEmailerr(true);
            flag=0;
        }
        if (gender=="") {
            setGendererr(true);
            flag=0;
        }

        console.log(gender)

        if (!/^\d{10}$/.test(phone)) {
            setPhoneerr(true);
            flag=0;
        }

        if (flag==1) {

            try {
                var fd=new FormData();
                fd.append("pid",localStorage.getItem("pid"));
                fd.append("name",name);
                fd.append("email",email);
                fd.append("gender",gender);
                fd.append("phone",phone);

                var resp=await axios.post("https://suvivah.org/suvivah/api/updatedashboard",fd);
                var data=resp.data;

                // setIsmsg(true);

                if (data.statusCode==200) {
                    Swal.fire({
                        icon: "success",
                        title: "Basic Information Update",
                        text: data.msg,
                        confirmButtonColor: "#dc3545",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: true
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Error Update",
                        text: data?.msg,
                        confirmButtonColor: "#dc3545",
                    });    
                }

            } catch (err) {
            
                Swal.fire({
                    icon: "error",
                    title: "Server Error",
                    text:
                        err.response?.data?.msg ||
                        "Something went wrong. Please try again later.",
                    confirmButtonColor: "#dc3545",
                });
    
            }
            
        }

    }

    useEffect(()=>{
        if (!localStorage.getItem("pid")) {
            let path=`/login`;
            navigate(path);
        }
        showprofile();
    },[])


    return(
        <>

<div className="devider"></div>


<section className="register-row">
<div className="container">
    <div className="row">
        <div className="col-md-3">

            <DashboardLeftNav />

        </div>
        <div className="col-md-9">
            <h2 className="pb-3">Dashboard</h2>
            

        <div className="register_box">
            <div className="row mb-3">
                <div className="col-md-12">
                    {ismsg?<div className="text text-success text-center">Profile Updated!!</div>:''}
                    <h4>Personal Details</h4>

                    
                </div>
                <div className="col-md-12">
                    <h6>Profile ID: {basicinfo.profile_id}</h6>
                </div>
                <div className="col-md-6">
                    <input type="text" className="form-control" value={name} onChange={(ev)=>{
                        setName(ev.target.value);
                        if (ev.target.value.length>0) {
                            setNameerr(false);
                        }
                    }} />
                    {nameerr?<div className="text text-danger text-small">Name Required</div>:''}
                </div>
                <div className="col-md-6">
                    <input type="email" className="form-control" value={email} onChange={(ev)=>{
                        setEmail(ev.target.value);
                        if (validator.isEmail(ev.target.value.length)) {
                            setEmailerr(false);
                        }
                    }} disabled={isEmailLocked} />
                    {emailerr?<div className="text text-danger text-small">Email Required</div>:''}
                </div>                
            </div>
            <div className="row mb-3">          
                <div className="col-md-6">
                    <select className="form-select" value={gender} onChange={(ev)=>{
                        setGender(ev.target.value);
                        if (ev.target.value.length>0) {
                            setGendererr(false);
                        }
                        }}
                    disabled={isGenderLocked}
                    >
                        <option value={""}>Select Gender</option>
                        <option value={"Male"}>Male</option>
                        <option value={"Femaile"}>Female</option>
                    </select>
                    {gendererr?<div className="text text-danger text-small">Select Gender</div>:''}
                </div>
                <div className="col-md-6">
                    <input
                        type="text"
                        className="form-control"
                        maxLength={10}
                        value={phone}
                        onChange={(ev) => {
                            setPhone(ev.target.value);
                            if (ev.target.value.length === 10) {
                                setPhoneerr(false);
                            }
                        }}
                        disabled={isPhoneLocked}
                    />
                    {phoneerr?<div className="text text-danger text-small">Phone Number Required</div>:''}
                </div>
            </div>

            <div className="row">
                <div className="col-md-12 text-center"><button type="button" className="btn btn-red px-5" onClick={updatedashboard}>Update</button></div>
            </div>

            
        </div>

        </div>
    </div>
</div>
</section>


        </>
    );
}

export default DashboardContent;